import { ComponentClass, FC, ReactNode } from 'react';
import { ContentState, EditorState, ContentBlock } from 'draft-js';

import { PublicUserProfile } from 'api';

export enum Modes {
  create = 'create',
  edit = 'edit',
}

export enum Format {
  html = 'html',
  text = 'text',
}

export interface IEditorProps {
  mode: Modes;
  format: Format;
  text?: string;
  placeholder?: string | ReactNode;
  className?: string;
  mentions?: PublicUserProfile[];
  disableToolbar?: boolean;
  disableMentions?: boolean;
  focusOnMount?: boolean;
  submitOnEnter?: boolean;
  onAddMention?: (user: PublicUserProfile) => void;
  onEnter?: (value: string) => void;
  onEscape?: () => void;
  onSpace?: (value: string) => void;
  onSubmit?: (value: string) => void;
  onChange?: (value: string) => void;
  onPaste?: (value: string) => void;
}

interface IFormattedProfile {
  name: string;
  full_name: string;
  id: string;
}

export interface IMentionPluginArgs {
  theme: IMentionsTheme;
}

interface IMentionSuggestionsProps {
  onSearchChange: (value: ISearchChange) => void;
  onAddMention: (user: PublicUserProfile) => void;
  onOpen: () => void;
  onClose: () => void;
  suggestions: IFormattedProfile[];
  entryComponent: FC;
}

export interface IMentionsTheme {
  mention: string;
  mentionSuggestions: string;
  mentionSuggestionsEntry: string;
  mentionSuggestionsEntryFocused: string;
  mentionSuggestionsEntryText: string;
}

export interface IMentionPlugin {
  MentionSuggestions: ComponentClass<IMentionSuggestionsProps>;
}

export interface IToolbarTheme {
  toolbar: string;
}

export interface IToolbarButtonTheme {
  buttonWrapper: string;
  button: string;
  active: string;
}

export interface IToolbarPluginArgs {
  theme: {
    toolbarStyles: IToolbarTheme;
    buttonStyles: IToolbarButtonTheme;
  };
}

export interface IToolbarPlugin {
  Toolbar: ComponentClass<any>;
}

export interface IToolbarPluginRenderProps {
  getEditorState: () => EditorState;
  onOverrideContent: (element: ReactNode) => void;
  setEditorState: (editorState: any) => void;
  theme: {
    buttonWrapper: string;
    button: string;
    active: string;
  };
}

export interface ILinkPlugin {
  LinkButton: (props: IToolbarPluginRenderProps) => JSX.Element;
}

export interface ILink {
  url: string;
}

export type Strategy = [ContentBlock, () => void, ContentState];
export type StrategyLookup = [string, ContentBlock, () => void, ContentState];

export interface IToolbarPlugins {
  toolbar: IToolbarPlugin;
  link: ILinkPlugin;
}

export interface ISearchChange {
  value: string;
}
